import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getMyProfile = () => {
  return apiRequestType(apiTypes.GET, apiConstants.PROFILE.MY_PROFILE);
};

export default getMyProfile;
